import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Popup,
  Form,
  Pager,
  Toolbar,
  Item,
  Lookup,
  Editing,
  RequiredRule,
  Label,
} from "devextreme-react/data-grid";
import { Button } from "devextreme-react";
import { formatMessage } from "devextreme/localization";
import { handleExportExcel } from "../../../../common";

const PermissionPolicies = [
  {
    PermissionPolicyId: 1,
    PermissionPolicyName: "Is Administrative",
  },
  {
    PermissionPolicyId: 2,
    PermissionPolicyName: "Deny all by default",
  },
  {
    PermissionPolicyId: 3,
    PermissionPolicyName: "Read only all by default",
  },
  {
    PermissionPolicyId: 4,
    PermissionPolicyName: "Allow all by default",
  },
];

export default function RoleTableList({
  dataSource,
  onSelectionChanged,
  renderActions,
  isXSmall,
  dataGrid,
  middleware,
}) {
  return (
    <DataGrid
      id="gridContainer"
      height={document.documentElement.offsetHeight - 189}
      dataSource={dataSource}
      showBorders={true}
      showRowLines={true}
      hoverStateEnabled={true}
      columnResizingMode="widget"
      rowAlternationEnabled={true}
      ref={(e) => {
        dataGrid.current = e;
      }}
      columnAutoWidth={true}
      allowColumnResizing={true}
      alignment="center"
      onSelectionChanged={(e) => onSelectionChanged(e)}
      // onExporting={(e) => handleExportExcel(e)}
    >
      <Editing
        mode="popup"
        useIcons={true}
        allowUpdating={middleware && middleware.WriteState}
        allowAdding={middleware && middleware.CreateState}
        allowDeleting={middleware && middleware.DeleteState}
      >
        <Popup
          title={formatMessage("RoleInfo")}
          showTitle={true}
          width={800}
          height={525}
        />
        <Form>
          <Item itemType="group" colCount={2} colSpan={2}>
            <Item dataField="RoleName">
              <Label text={formatMessage("RoleName")} />
            </Item>
            <Item dataField="PermissionPolicy">
              <Label text={formatMessage("PermissionPolicy")} />
            </Item>
            <Item dataField="IsActive">
              <Label text={formatMessage("IsActive")} />
            </Item>
          </Item>
          <Item itemType="group" colCount={2} colSpan={2}>
            <Item dataField="Remarks" editorType="dxTextArea" colSpan={2}>
              <Label text={formatMessage("Remarks")} />
            </Item>
          </Item>
        </Form>
      </Editing>
      <Selection
        mode="multiple"
        selectAllMode="page"
        showCheckBoxesMode="always"
      />
      <FilterRow visible={true} />
      <Paging defaultPageSize={10} />

      <Pager
        showPageSizeSelector={true}
        allowedPageSizes={[10, 20, 50, 100]}
        showInfo={true}
        visible={true}
      />
      <Column type="buttons">
        <Button name="delete" />
        <Button name="edit" />
        <Button name="save" />
        <Button name="cancel" />
      </Column>
      <Column
        caption={formatMessage("Action")}
        cellRender={renderActions}
        alignment="center"
        // width={120}
      />
      <Column
        caption={formatMessage("RoleName")}
        dataField="RoleName"
        dataType="string"
        allowSearch={true}
      >
        <RequiredRule />
      </Column>
      <Column
        caption={formatMessage("PermissionPolicy")} // cho ngta select
        dataField="PermissionPolicy"
      >
        <Lookup
          dataSource={PermissionPolicies}
          displayExpr="PermissionPolicyName"
          valueExpr="PermissionPolicyId"
        >
          <RequiredRule />
        </Lookup>
      </Column>
      <Column
        caption={formatMessage("Remarks")}
        dataField="Remarks"
        dataType="string"
      />
      <Column
        caption={formatMessage("IsActive")}
        dataField="IsActive"
        alignment="center"
        // cellRender={(e) => renderCheckboxActive(e)}
      ></Column>
      <Toolbar>
        <Item
          location="after"
          locateInMenu={isXSmall ? "always" : "auto"}
          cssClass={"datagrid-toolbar-actions-dropdown"}
        >
          {/* {selectedRowKeys.length === 1 && (
            <Button icon="edit" text="Edit" className="mr-1" />
          )} */}
          {middleware && middleware.ExportState && (
            <Button
              onClick={() => handleExportExcel(dataGrid, "RoleList")}
              icon="export"
              text={formatMessage("Export")}
              className="mr-1"
              name="export"
            />
          )}
          <Button
            icon="revert"
            text={formatMessage("Refresh")}
            onClick={() => dataGrid.current.instance.refresh()}
            name="revertButton"
            className="mr-1"
          />
          {middleware && middleware.CreateState && (
            <Button
              icon="plus"
              text={formatMessage("NewRole")}
              onClick={() => dataGrid.current.instance.addRow()}
              stylingMode="outlined"
              type="default"
            />
          )}
        </Item>
      </Toolbar>
    </DataGrid>
  );
}
